<style>
.next button {
    background: #FF0000!important;
    border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
    color: #FFFFFF!important;
    width: 160px;
    height: 44px;
    margin: auto;
    cursor: pointer;
}
.next {
    text-align: center;
    padding-top: 10px;
}
.tabscontent{
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding-top: 85px;

}
.middle .tabscontent {
    padding-top: 0;
}
#innerEquip{
    flex: 1;
}
.middle .tabcontent {
    flex-direction: column;
    min-width: 300px;
    max-width: 400px;
    flex: unset!important;
}

.tabCat .active{
border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
}
.tablinksCat{
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 5px;
    width: 275px;
    text-align: left;
    padding-left: 40px;
    height: 44px;
    background-repeat: no-repeat;
    /*background-image: url(https://sun9-34.userapi.com/c629417/v629417849/33129/9XFMWYCqRas.jpg);*/
    background-size: contain;
}
.tabCat {
    display: flex;
    flex-direction: column;
}
button.tablinksCat1, button.tablinksCat, button.tablinksCat2 {
    width: 313px;
    height: 46px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    text-align: center;
    justify-content: left;
    align-content: flex-start;
    align-items: center;
    background: #fff;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    font-family: Gotham Pro, sans-serif;
    color: #404455;
    margin-top: 11px;
    cursor: pointer;
}
.middle button.tablinksCat1, .middle button.tablinksCat, .middle button.tablinksCat2 {
    display: none;
}
.tabCat .select_container {
    display: none;
}
.middle .tabCat .select_container {
    display: block;
}
.select_container {
    --border: 1px solid #f00;
    --placeholderColor: #f00;
    --itemActiveBackground: #ffe7e7;
    --itemIsActiveBG: #ffe7e7;
    --itemIsActiveColor: #000;
    --itemHoverBG: #ffe7e7;
    --borderFocusColor: #f00;
  }
img.tab_image {
    width: 24px;
    height: 24px;
    padding-right: 0.4em;
}
.item_inner {
    display: flex;
}
.middle .item_inner {
    flex-wrap: wrap;
}
.item {
    display: flex;
    flex: 1;
    margin-right: 0;
    margin-top: 10px;
    background: #F4F4F4;
    margin-bottom: 0;
    padding: 10px;
    cursor: pointer;
    align-items: center;
}
.item img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 6px;
}
img.item_image {
    width: 81px;
    height: 81px;
    padding-right: 10px;
}
.item_descr_large {
    flex: 1;
}
.middle .item {
    min-width: unset;
    flex: 1;
    margin-right: 0;
    margin-bottom: 2px;
    justify-content: center;
}
.middle .check {
    margin-bottom: 2px;
    min-width: unset;
    flex: 1;
}

.checkContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
}
.checkContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  z-index: 99999;
  height: 14px;
  width: 14px;
}
.checkmark {
  position: absolute;
  height: 14px;
  width: 14px;
  background: #FFFFFF;
  border: 0.5px solid #C4C4C4;
}
.checkContainer:hover input ~ .checkmark {
  background-color: #FFFFFF;
}
.checkContainer input:checked ~ .checkmark {
  background-color: #FFFFFF;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.checkContainer input:checked ~ .checkmark:after {
  display: flex;
}
.checkContainer .checkmark:after {
    left: 4px;
    top: -1px;
    width: 4px;
    height: 9px;
    border: solid #FF0000;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.disabled_checkbox {
    opacity: .6;
}

.item_descr_large {
    flex: 1;
}
.middle .item_descr {
    width: 100%;
    background: #F4F4F4;
    padding: 15px;
    margin-bottom: 14px;
}

.next button, .prev button {
    background: #FF0000!important;
    border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
    color: #FFFFFF!important;
    width: 120px;
    height: 44px;
    margin: auto;
    font-weight: bold;
    cursor: pointer;
    transition: 0.25s;
}
.next button:hover {
    background-color: #DD0000!important;
    color: #FFFFFF;
}
.next button:active, .next button:focus {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;
    box-shadow: 0 0 0 0.2rem #FF000060;
}
.prev button {
    background-color: #FFFFFF!important;
    color: #FF0000!important;
    cursor: pointer;
}
.prev button:hover {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;;
}
.prev button:active, button:focus {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;;
    box-shadow: 0 0 0 0.2rem #ff000060;
}
.next, .prev {
    text-align: center;
    padding-top: 10px;
    float: left;
}
.next {
    float: right;
}
.mainTabContentWrapNav {
    max-width: 752px;
    margin: auto;
    padding-top: 20px;
}
.middle.mainTabContentWrapNav:after {
    content: "";
    display: block;
    clear: both;
}
.step3 {
    position: relative;
    padding: 20px 20px;
    border-radius: 20px;
}
.h2_area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
}
.h2_area_outer {
    padding-top: 33px;
    padding-bottom: 0;
}
.h2_area_additional {
    padding-top: 20px;
    padding-bottom: 0;
}
.h2_area_text {
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    color: #404455;
}
.h2_area_help {
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 10px;
    border: 1px solid #C4C4C4;
    color: #C4C4C4;
    font-size: 12px;
    text-align: center;
    line-height: 14px;
    cursor: pointer;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}
.addButton {
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    height: 15px;
    padding-left: 30px;
    color: #FF0000;
    cursor: pointer;
    position: relative;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    margin-top: -4px;
    padding-right: 5px;
}
.addButton:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #FF0000;
    width: 14px;
    height: 14px;
    border-radius: 15px;
    border: 1px solid #FF0000;
    text-align: center;
    background-image: url("./images/mini-plus.svg");
    background-size: 10px;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: 1px;
}
.item_name {
    font-weight: 600;
    font-size: 14px;
    line-height: 13px;
    color: #404455;
    flex: 1;
}
.button_delete {
    width: 23px;
    height: 23px;
    border-radius: 20px;
    background-image: url("./images/delete.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 10px;
}
</style>
<script>
    import { mutations, goodsList, responsiveClass, first } from '../mainStore.js';
    import { onMount } from 'svelte'
    import TrackConstructor from './MainTabs/TrackConstructor.svelte';
    import Modal from './modal.svelte'

    onMount(() => {
        if (!$first) {
            mutations.setFirst(true);
            setTimeout(openInfo, 30)
        }
        window.scrollTo(0,0)
    })

    function openInfo() {
        mutations.setModalState(1)
        mutations.setModalType("info")
        mutations.setShowModal(true)
        mutations.setModalTitle("")
    }
    let element
    $: if (element) {
        mutations.setHelpIconRect(element.getBoundingClientRect())
    }

    function addOuter() {
        mutations.setTabName("outer")
        mutations.setModalState("outer")
        mutations.setModalType("items")
        mutations.setShowModal(true)
        mutations.setModalTitle("Внешняя оснастка")
        mutations.setSelectedPlusItem(null)
    }
    function addAdditional() {
        mutations.setTabName("additional")
        mutations.setModalState("additional")
        mutations.setModalType("items")
        mutations.setShowModal(true)
        mutations.setModalTitle("Дополнительная оснастка")
        mutations.setSelectedPlusItem(null)
    }
    function getDummy(){
        return "/build/images/No Image.png"
    }

    function getTabImage(item) {
        if(item.icon_image){
            return item.icon_image
        } else {
            if(item.category.image){
                return item.category.image
            }
            return getDummy()
        }
    }
    function deleteItem(item) {
        mutations.setModalState({
            modalType: null,
            modalState: null,
            modalTitle: "",
            showModal: false,
            item: item,
        })
        mutations.setModalType("confirmation")
        mutations.setShowModal(true)
        mutations.setModalTitle("")
    }
    function openItem(item) {
        mutations.setModalState(item)
        mutations.setModalType("oneItem")
        mutations.setShowModal(true)
        mutations.setModalTitle(item.name)
    }
    $: console.log("$goodsList: ", $goodsList)
</script>

<div class="step3">
    <div class="h2_area">
        <div class="h2_area_text">Внутренняя оснастка</div>
        <div class="h2_area_help" bind:this={element} on:click={openInfo}>?</div>
    </div>

    <TrackConstructor />

    <div class="h2_area h2_area_outer">
        <div class="h2_area_text">Внешняя оснастка</div>
        <div class="addButton" on:click={addOuter}>Добавить</div>
    </div>
    {#each $goodsList as item}
        {#if (item.tabName == "outer")}
            <div class="item" on:click={() => openItem(item)} >
                <img src="{getTabImage(item)}" alt="">
                <div class="item_name">{item.name}</div>
                <div class="button_delete" on:click|stopPropagation={() => deleteItem(item)} ></div>
            </div>
        {/if}
    {/each}
    <div class="h2_area h2_area_additional">
        <div class="h2_area_text">Дополнительная оснастка</div>
        <div class="addButton" on:click={addAdditional}>Добавить</div>
    </div>
    {#each $goodsList as item}
        {#if (item.tabName == "additional")}
            <div class="item" on:click={() => openItem(item)} >
                <img src="{getTabImage(item)}" alt="">
                <div class="item_name">{item.name}</div>
                <div class="button_delete" on:click|stopPropagation={() => deleteItem(item)}></div>
            </div>
        {/if}
    {/each}
    <div class="h2_area h2_area_additional">
        <div class="h2_area_text">Товары внутренней оснастки</div>
    </div>
    {#each $goodsList as item}
        {#if (item.tabName == "top" || item.tabName == "bottom")}
            <div class="item" on:click={() => openItem(item)} >
                <img src="{getTabImage(item)}" alt="">
                <div class="item_name">{item.name}</div>
                <div class="button_delete" on:click|stopPropagation={() => deleteItem(item)}></div>
            </div>
        {/if}
    {/each}
    <div class="mainTabContentWrapNav {$responsiveClass}">
        <div class="prev">
            <a href="#step2">
                <button on:click="{()=>{mutations.setStep(2);}}">Назад</button>
            </a>
        </div>
        <div class="next">
            <a href="#step4">
                <button href="#step4" on:click="{()=>mutations.setStep(4)}">Далее</button>
            </a>
        </div>
    </div>

    <Modal />
</div>

